const round = (number) => Math.round(number * 100) / 100;

export const calculateLine = (quantity = 1, ratio) => {
  return round(quantity / ratio);
};

export const calculateLegend = (quantity = 1, squareFootage, ratio) => {
  return round((quantity * squareFootage) / ratio);
};

export const calculateLettering = (
  quantity = 1,
  text = '',
  letterSet,
  ratio,
  throwError = false
) => {
  return text
    .split('')
    .filter((letter) => letter !== ' ')
    .reduce((accum, letter) => {
      if (!letterSet.hasOwnProperty(letter)) {
        if (throwError) throw new Error(`${letter} is not added to the lettering set`);
        return accum;
      }
      return accum + round((quantity * letterSet[letter]) / ratio);
    }, 0);
};

export const materialCalculations = (material) => {
  const { materialSpecifications } = material || {};
  if (!material || !materialSpecifications || material.materialType === 'each') {
    return;
  }
  const { line, legend, lettering } = materialSpecifications;

  if (line) {
    if (line.isSF) {
      return round(material.quantity);
    }
    return calculateLine(material.quantity, line.ratio);
  } else if (legend) {
    return calculateLegend(material.quantity, legend.squareFootage, legend.ratio);
  } else if (lettering) {
    return calculateLettering(
      material.quantity,
      material.letteringText,
      lettering.letterSet,
      lettering.ratio
    );
  }
};
